<template>
  <div style="display: flex; align-items: center">
    <el-pagination
      v-if="showPagination"
      class="ag-table-el-pagination"
      :current-page.sync="curPage"
      :page-size.sync="curPageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[100, 200, 500, 1000, 5000, 10000, 15000]"
      :pager-count="5"
      size="mini"
      background
      layout="prev, pager, next, sizes, total"
      :total="params.getTotal()"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  props: {},
  computed: {
    showPagination () {
      return this.params.showPagination()
    },
    curPage: {
      get () {
        return this.params.currentPage()
      },
      set (val) {
        this.params.updateCurrentPage(val)
      }
    },
    curPageSize: {
      get () {
        return this.params.pageSize()
      },
      set (val) {
        this.params.updatePageSize(val)
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.curPage = 1
      this.params.handleSizeChange(val)
    },
    handleCurrentChange (val) {
      this.params.handleCurrentChange(val)
    }
  }
}
</script>

<style lang="scss">
.ag-table-el-pagination {
  --el-pagination-border-radius: 2px;
  --el-border-radius-base: 2px;
}
</style>
